export default {
    COMMERCIAL_CLOUD: 'Commercial Cloud',
    DATA_CLOUD: 'Data Cloud',
    DEVELOPMENT_CLOUD: 'Development Cloud',
    QUALITY_CLOUD: 'Quality Cloud',
    CONSULTING: 'Consulting',
    SERVICES: 'Services',
};
